export default function CompletedIcon() {
  return (
    <svg
      width="22"
      height="15"
      viewBox="0 0 22 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.7494 11.25H17.7494M10.2494 11.25H11.7494M1.24939 4.5799H20.7494M1.99994 0.75H19.9999C20.4142 0.75 20.7499 1.08579 20.7499 1.5V13.5C20.7499 13.9142 20.4142 14.25 19.9999 14.25H1.99994C1.58573 14.25 1.24994 13.9142 1.24994 13.5V1.5C1.24994 1.08579 1.58573 0.75 1.99994 0.75Z"
        stroke="#B721FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
